
import React, { useEffect, useState } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  InputBase,
  IconButton,
  Divider,
  Tooltip,
  Button,
  Checkbox
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from 'react-router-dom';

interface Asset {
  id: string;
  name: string;
  type: string;
  vendor: string;
  region: string;
}

interface AssetTableProps {
  title: string;
  assets: any[];
  ButtonLabel: string;
  ButtonColor: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
  ButtonONClick: (assets:any) => void;
  removeIcon:boolean,
  handleAddAsset?: (asset: any) => void;  // Function to add asset
  handleRemoveAsset?: (asset: any) => void;  // Function to remove asset
  setSelectedRows?: string[];
}

const AssetTable: React.FC<AssetTableProps> = ({ title, assets,ButtonLabel,ButtonColor ,ButtonONClick,removeIcon,handleAddAsset, handleRemoveAsset,setSelectedRows}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [updatedAssets, setUpdatedAssets] = useState([...assets]);
  //console.log(assets);
  //console.log(updatedAssets);
  const [selectedRow, setSelectedRow] = useState<number | null>(null);
  const [localSelectedRows, setLocalSelectedRows] = useState<string[]>(() => (setSelectedRows ? [] : []));
  const location = useLocation();
    let module= "";
        //const location = useLocation();
        console.log(location.pathname,"location.pathname");
        if(location.pathname=='on-premises/assets'){
          module="on_premise"
    
        } else {
    
           module ="cloud"
        }
  
  useEffect(() => {
    setUpdatedAssets(assets);
  }, [assets]);
  const handleCheckboxChange = (assetTemp: any) => {
    // setLocalSelectedRows(prevSelectedRows => {
    //   if (prevSelectedRows.includes(assetId)) {
    //     return prevSelectedRows.filter(id => id !== assetId);  // Uncheck
    //   } else {
    //     return [...prevSelectedRows, assetId];  // Check
    //   }
    // });
    const updatedAssetsList = updatedAssets.map((asset) => 
      asset.id === assetTemp.id
        ? { ...asset, isChecked: !asset.isChecked }  // Toggle the isChecked value
        : asset
    );
    setUpdatedAssets(updatedAssetsList);
    //setUpdatedAssets(updatedAssetsList);

  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setLocalSelectedRows(assets.map((asset) => asset.id)); // Select all
    } else {
      setLocalSelectedRows([]); // Deselect all
    }
  };
  
  const filteredAssets = assets.filter(asset => 
    asset.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
    asset.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
    asset.vendor.toLowerCase().includes(searchTerm.toLowerCase()) ||
    asset.region.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  console.log(assets);
  console.log(updatedAssets);
  return (
    <Paper sx={{ 
      height: '100%', 
      borderRadius: '8px', 
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Box sx={{ p: 2 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
          {title}
        </Typography>
        {/* <Button variant='outlined' color={ButtonColor} onClick={ButtonONClick}>{ButtonLabel}</Button> */}
        <Button 
            variant='outlined' 
            color={ButtonColor} 
            onClick={() => ButtonONClick(updatedAssets.filter(asset => asset.isChecked))}  // Pass only checked assets
            disabled={updatedAssets.every(asset => !asset.isChecked)}  // Disable if no rows are selected
          >
            {ButtonLabel}
          </Button>
        </div>
        
        {/* <Box sx={{ 
          display: 'flex', 
          alignItems: 'center',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          p: '2px 4px',
        }}>
          <IconButton sx={{ p: '8px' }} aria-label="search">
            <SearchIcon />
          </IconButton>
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search Assets"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          <Tooltip title="Filter list">
            <IconButton sx={{ p: '8px' }} aria-label="filter">
              <FilterListIcon />
            </IconButton>
          </Tooltip>
        </Box> */}
      </Box>

      <Divider />

      <TableContainer sx={{ flexGrow: 1 }}>
        <Table stickyHeader size="small" aria-label="assets table">
          <TableHead>
            <TableRow>
              <TableCell width="5%" sx={{ fontWeight: 'bold', py: 1.5, fontSize: '0.875rem', borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>#</TableCell>
              <TableCell width="25%" sx={{ fontWeight: 'bold', py: 1.5, fontSize: '0.875rem', borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>Name</TableCell>
              <TableCell width="20%" sx={{ fontWeight: 'bold', py: 1.5, fontSize: '0.875rem', borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>Type</TableCell>
              <TableCell width="20%" sx={{ fontWeight: 'bold', py: 1.5, fontSize: '0.875rem', borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>Vendor</TableCell>
              <TableCell width="25%" sx={{ fontWeight: 'bold', py: 1.5, fontSize: '0.875rem', borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>Region</TableCell>
              <TableCell width="5%" sx={{ fontWeight: 'bold', py: 1.5, fontSize: '0.875rem', borderBottom: '1px solid rgba(224, 224, 224, 1)' }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {updatedAssets.map((asset, index) => (
              <TableRow
                key={index}
                onClick={() => setSelectedRow(index)}
                sx={{ 
                  '&:last-child td, &:last-child th': { border: 0 },
                  '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
                  bgcolor: selectedRow === index ? 'rgba(64, 72, 238, 0.08)' : 'transparent',
                  cursor: 'pointer'
                }}
              >
                <TableCell component="th" scope="row" sx={{ py: 1.5, fontSize: '0.875rem' }}>
                <Checkbox
                  checked={asset.isChecked} 
                  onChange={() => handleCheckboxChange(asset)} 
                />
                </TableCell>
                <TableCell sx={{ py: 1.5, color: '#4048ee', fontSize: '0.875rem' }}>{asset.name}</TableCell>
                <TableCell sx={{ py: 1.5, fontSize: '0.875rem' }}>{asset?.asset_category}</TableCell>
                <TableCell sx={{ py: 1.5, fontSize: '0.875rem' }}>{asset?.asset_vendor}</TableCell>
                <TableCell sx={{ py: 1.5, fontSize: '0.875rem' }}>{asset?.region_name}</TableCell>
                <TableCell sx={{ py: 1.5, fontSize: '0.875rem' }}>
                  {removeIcon ? (
                    <IconButton
                      color="error"
                      onClick={() => handleRemoveAsset && handleRemoveAsset(asset)}
                      size="small"
                    >
                      <CloseIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      color="primary"
                      onClick={() => handleAddAsset && handleAddAsset(asset)}
                      size="small"
                    >
                      <AddIcon />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {updatedAssets.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                  No assets found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default AssetTable;